<script setup lang="ts">
    import { computed, toRef } from 'vue'

    import AlternativesViewDependenciesList from '@Alternatives/AlternativesViews/Components/AlternativesViewDependenciesList.vue'
    import type { AlternativesViewDependenciesDialogViewModel } from '@Alternatives/AlternativesViews/Components/AlternativesViewDependenciesDialog'

    // ---------------- props ----------------

    const props = defineProps<{
        viewModel: AlternativesViewDependenciesDialogViewModel
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const initialized = computed(() => vm.value?.initialized ?? false)

    const name = computed(() => vm.value.name)
    const dependenciesCount = computed(() => vm.value.dependenciesCount)

    const reports = computed(() => vm.value.reports)
    const lists = computed(() => vm.value.lists)
    const estimationsSurveys = computed(() => vm.value.estimationsSurveys)

    // ---------------- methods ----------------s ----------------

    function close()
    {
        vm.value.close()
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">List dependencies</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div v-if="initialized" class="alert alert-warning text-dark" role="alert">
                            <p>The list '<strong>{{name}}</strong>' is used in <strong>{{dependenciesCount}}</strong> places.</p>
                        </div>
                        <AlternativesViewDependenciesList :initialized="initialized"
                                                          :reports="reports"
                                                          :lists="lists"
                                                          :estimationsSurveys="estimationsSurveys" />
                    </div>
                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>